import './SpecialInstructions.scss';
import Component from './SpecialInstructions.js';
export default Component;
